import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import esTranslations from '../../translation/translate-es.json';
import enTranslations from '../../translation/translate-en.json';

// Definimos el tipo para nuestro estado
interface LanguageState {
  language: 'es' | 'en';
  translations: typeof esTranslations; // Usamos la estructura de esTranslations como base
}

// Intentamos obtener el idioma guardado del localStorage
const savedLanguage = localStorage.getItem('language') as 'es' | 'en' | null;
// Si no hay nada guardado, usamos 'en' como predeterminado
const initialLanguage = savedLanguage || 'en';

const initialState: LanguageState = {
  language: initialLanguage,
  // Si es 'es' usa español, si no (es 'en') usa inglés
  translations: initialLanguage === 'es' ? esTranslations : enTranslations,
};

const languageSlice = createSlice({
  name: 'language',
  initialState,
  reducers: {
    setLanguage: (state, action: PayloadAction<'es' | 'en'>) => {
      state.language = action.payload;
      state.translations = action.payload === 'es' ? esTranslations : enTranslations;
      localStorage.setItem('language', action.payload);
    },
    toggleLanguage: (state) => {
      const newLang = state.language === 'es' ? 'en' : 'es';
      state.language = newLang;
      state.translations = newLang === 'es' ? esTranslations : enTranslations;
      localStorage.setItem('language', newLang);
    },
  },
});

export const { setLanguage, toggleLanguage } = languageSlice.actions;
export default languageSlice.reducer;
